module.exports = __webpack_public_path__ + "img/home-nav-icon-4.72a79552.png";